/* Lo stato "credenziali da sistemare" di un account SalesMate, detto in italiano.

   Il portale segna l'account (campo `ko`, la data del guasto) quando rifiuta le credenziali
   o quando impone il cambio password: l'email parte una volta sola, quindi l'avviso deve
   restare VISIBILE qui finche' non si sistema — il 17/09/2026 un account era KO dal 23
   agosto, primo in lista, e nessuno poteva saperlo guardando la scheda. Funzione pura. */
export function avvisoCredenziali(utente) {
  const ko = (utente || {}).ko;
  if (!ko) return '';
  const d = new Date(ko);
  const quando = Number.isNaN(d.getTime())
    ? '' : ` · dal ${d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}`;
  return `credenziali da sistemare${quando}`;
}

/** Il consiglio, uguale a quello dell'email: prima il portale, poi qui. */
export const COSA_FARE_CREDENZIALI =
  'Cambia la password sul portale TIM e poi aggiornala qui con «Password».';


/* Il semaforo della scheda: verde se l'ultima prova di login e' andata bene, rosso se no,
   niente se non e' mai stata fatta. Serve a sapere SUBITO se la password appena messa e'
   quella giusta, invece di scoprirlo quando l'agente si ferma (18/09/2026). */
export function semaforo(utente) {
  const u = utente || {};
  if (u.ko) return { colore: 'var(--err)', testo: 'credenziali da sistemare' };
  if (u.provata_ok === true) return { colore: 'var(--ok)', testo: `password verificata${quando(u.provata_at)}` };
  if (u.provata_ok === false) return { colore: 'var(--err)', testo: `password rifiutata${quando(u.provata_at)}` };
  return null;
}

function quando(at) {
  if (!at) return '';
  const d = new Date(at);
  return Number.isNaN(d.getTime()) ? '' : ` il ${d.toLocaleDateString('it-IT')}`;
}
